<template>
    <div class="imagedetail">
        <div class="left">
            <div class="Mental">
                <p class="title"><i><img src="@/assets/Userportrait/img13.png" alt=""></i>心理健康</p>
                <div class="MentalHealth">
                    <div v-for="item in ProfilData.psyProfilHealth">
                        <span>{{item.factorName}}：</span>
                        <label :style="{'color':item.colorName}">{{item.resultGrade}}<i :style="{'background':item.colorName,'opacity':0.1}"></i></label>
                    </div>
                </div>
            </div>

            <div class="Preferences">
                <p class="title"><i><img src="@/assets/Userportrait/img9.png" alt=""></i>偏好特征</p>
                <div id="myChart" ref="myChart" style="width:390px;height:350px;"></div>
            </div>
        </div>
        <div class="middle">
            <div class="middle_img">
                <span v-for="item in ProfilData.psyProfilCharacter" :style="{'background':generateRandomColor()}" class="tags" >{{ item.factorName }}</span>
            </div>
            <div class="info">
                <span>{{ProfilData.realName}}</span>
                <span>{{ProfilData.sex}}</span>
                <span>{{ProfilData.ages}}岁</span>
                <span>{{ProfilData.profName}}</span>
            </div>
        </div>
        <div class="right">
            <div class="Psychological">
                <p class="title"><i><img src="@/assets/Userportrait/img11.png" alt=""></i>生理数据</p>
                <div class="Data">
                    <div class="item">
                        <div class="icons"><img src="@/assets/Userportrait/img16.png"></div>
                        <b>{{ProfilData.heartRate}}</b>
                        <p>心率</p>
                    </div>
                    <div class="item">
                        <div class="icons"><img src="@/assets/Userportrait/img8.png"></div>
                        <b>{{ProfilData.pressBody}}</b>
                        <p>身体压力</p>
                    </div>
                    <div class="item">
                        <div class="icons"><img src="@/assets/Userportrait/img7.png"></div>
                        <b>{{ProfilData.pressMin}}</b>
                        <p>精神压力</p>
                    </div>
                </div>
            </div>

            <!-- 心理能力 -->
            <div class="mentalability">
                <p class="title"><i><img src="@/assets/Userportrait/img20.png" alt=""></i>心理能力</p>
                <div class="item">
                    <p class="subtitle"><span>智</span><span>商</span><span>水</span><span>平</span></p>
                    <p class="content" v-html="ProfilData.iqresult"></p>
                </div>
                <div class="item">
                    <p class="subtitle" style="margin-bottom: 20px;"><span>智</span><span>力</span><span>结</span><span>构</span></p>
                    <div class="Intellectualstructure">
                        <p v-for="item in ProfilData.psyProfilIntelligence"><span>{{item.factorName}} </span><label :class="'evaluate'+(Math.floor(Math.random() * 4)+1)">{{item.resultGrade}}</label></p>
                    </div>
                    <!-- <div class="items">
                        <p><span>语言能力 </span><label class="evaluate5">优秀</label></p>
                        <p><span>音乐</span><label class="evaluate3">中等</label></p>
                    </div>
                    <div class="items">
                        <p><span>逻辑数学</span><label class="evaluate5">优秀</label></p>
                        <p><span>自然环境</span><label class="evaluate2">中下</label></p>
                    </div>
                    <div class="items">
                        <p><span>空间视觉</span><label class="evaluate5">优秀</label></p>
                        <p><span>人际关系</span><label class="evaluate3">中等</label></p>
                    </div>
                    <div class="items">
                        <p><span>运动能力</span><label class="evaluate4">中上</label></p>
                        <p><span>自我内省</span><label class="evaluate1">低下</label></p>
                    </div> -->
                </div>
                <div class="item">
                    <p class="subtitle"><span>情</span><span>商</span><span>水</span><span>平</span></p>
                    <p class="content" v-html="ProfilData.eqresult"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            UserID:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            ProfilData:'',
            dropKeyContent:[],
            readQnty:[],
            color:['#45C2E0','#C1EBDD','#FFC851','#5A5476','#1869A0','#FF9393','#45C2E0','#C1EBDD','#FFC851','#5A5476','#1869A0','#FF9393'],
        }
    },
    mounted() {
        this.GetProfil();
    },
    methods: {
        GetProfil(){
            this.$Http_Post('/kg/profil/GetProfil',{UserID:this.UserID}).then(res=>{
                if(res.Code==0){
                    this.ProfilData=res.Data;
                    let psyProfilPreference=res.Data.psyProfilPreference
                    for(var i=0;i<psyProfilPreference.length;i++){
                        this.dropKeyContent.push(psyProfilPreference[i].dropKeyContent);
                        let str={value: psyProfilPreference[i].readQnty,itemStyle: {color:this.color[i]}}
                        this.readQnty.push(str);
                    }
                    this.init();
                }
            })
        },

        init(){
            let myChart = this.$echarts.init(this.$refs.myChart);
            var option={
                grid: { 
                    left: 70,
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                },
                yAxis: {
                    type: 'category',
                    data:this.dropKeyContent,
                },
                series: [{
                    type: 'bar',
                    data:this.readQnty,
                },
                ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 生成颜色
        generateRandomColor(){
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
    }
    
}
</script>
<style scoped>
img{width: 100%;display: block;}
.imagedetail{background: radial-gradient(50% 50%, #F4F8FB 35.42%, #D9E6FA 100%);display: flex;padding:40px 33px;min-width: 1580px;}
.imagedetail .left,.imagedetail .right{width: 390px;}
.imagedetail .middle{flex: 1;}
.imagedetail .middle .middle_img{width: 597px;height:549px;background:url("../../../assets/Userportrait/img19.png") no-repeat;background-size: 100%;margin:65px auto 0;position:relative;}
.imagedetail .middle .middle_img .tags{width: 145px;line-height: 37px;font-size: 22px;border-radius: 200px;color: #fff;display: inline-block;text-align:center;position:absolute;}
.imagedetail .middle .middle_img .tags:nth-child(1){top:0;left:60px;animation: driftanimation 15s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(2){top: 60px;left:-29px;animation: driftanimation 13s 1s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(3){top: 130px;left:-89px;animation: driftanimation 20s .5s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(4){top:200px;left:-30px;animation: driftanimation 18s 2s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(5){top:270px;left:-35px;animation: driftanimation 15s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(6){top:330px;left:-89px;animation: driftanimation 10s .2s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(7){top:400px;left:-25px;animation: driftanimation 17s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(8){top:470px;left:-10px;animation: driftanimation 25s .5s linear infinite;}

.imagedetail .middle .middle_img .tags:nth-child(9){top:0;right:60px;animation: driftanimation 21s .1s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(10){top: 60px;right:-29px;animation: driftanimation 23s .4s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(11){top: 130px;right:-89px;animation: driftanimation 22s 3s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(12){top:200px;right:-30px;animation: driftanimation 13s .1s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(13){top:270px;right:-35px;animation: driftanimation 14s .8s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(14){top:330px;right:-89px;animation: driftanimation 15s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(15){top:400px;right:-25px;animation: driftanimation 10s 1s linear infinite;}
.imagedetail .middle .middle_img .tags:nth-child(16){top:470px;right:-10px;animation: driftanimation 16s .7s linear infinite;}
.imagedetail .middle .info{display: flex;max-width:500px;margin:40px auto 0;}
.imagedetail .middle .info span{flex: 1;border-right:1px solid #C7C7C7;text-align: center;font-size:22px;}
.imagedetail .middle .info span::before{content: '';width: 10px;height: 10px;background: #2561ED;border-radius: 50%;display: inline-block;margin-right:10px;position: relative;top: -3px;}
.imagedetail .middle .info span:nth-child(2)::before{background: #FF9900;}
.imagedetail .middle .info span:nth-child(3)::before{background: #FF6666;}
.imagedetail .middle .info span:nth-child(4)::before{background: #92D9A1;}
.imagedetail .middle .info span:last-child{border-right:none;}
.imagedetail .left .Mental{background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;border-radius: 16px;}
.imagedetail .left .Mental .title{border-radius: 16px 16px 0 0;background: linear-gradient(180deg, #8CDB53 0%, #599C2D 100%);padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.imagedetail .left .Mental .title i{width:22px;display: inline-block;margin-right: 10px;position: relative;top:5px;}
.imagedetail .left .Mental .MentalHealth{font-size: 14px;display: flex;flex-wrap: wrap;padding:0 15px;min-height: 200px;}
.imagedetail .left .Mental .MentalHealth div{font-size: 14px;display: block;width: 50%;padding: 10px 0;}

.imagedetail .left .Mental .MentalHealth div span{display: inline-block;width: 100px;text-align: right;}
.imagedetail .left .Mental .MentalHealth div label{border-radius: 50px;width: 72px;line-height: 22px;text-align: center;display: inline-block;position: relative;}
.imagedetail .left .Mental .MentalHealth div label i{position: absolute;top: 0;left: 0;width: 100%;height: 100%;border-radius: 200px;}
.imagedetail .left .Preferences{background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;border-radius: 16px;margin-top:40px;}
.imagedetail .left .Preferences .title{border-radius: 16px 16px 0 0;background:linear-gradient(180deg, #E35252 0%, #B33E3E 100%);;padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.imagedetail .left .Preferences .title i{width:22px;display: inline-block;margin-right: 10px;position: relative;top: 5px;}
.imagedetail .right .Psychological{border-radius: 16px;background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;margin-bottom:40px;}
.imagedetail .right .Psychological .title{border-radius: 16px 16px 0 0;background:linear-gradient(180deg, #EBA844 0%, #BF842C 100%);padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.imagedetail .right .Psychological .title i{width: 22px;display: inline-block;margin-right: 10px;position: relative;top:5px;}
.imagedetail .right .Psychological .Data{display: flex;}
.imagedetail .right .Psychological .Data .item{text-align: center;flex: 1;padding:20px 0 16px;margin: 16px 0;}
.imagedetail .right .Psychological .Data .item:nth-child(2){border-left:1px dashed #BCD1F5;border-right:1px dashed #BCD1F5;}
.imagedetail .right .Psychological .Data .icons{width:52px;margin: auto;height: 45px;}
.imagedetail .right .Psychological .Data b{font-size:24px;color: #C1862D;text-align: center;padding-top: 20px;display: inline-block;}
.imagedetail .right .Psychological .Data p{text-align:center;font-size: 16px;}
.imagedetail .right .mentalability{border-radius: 16px;background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;padding-bottom: 13px;}
.imagedetail .right .mentalability .title{border-radius: 16px 16px 0 0;background:linear-gradient(180deg, #4C7AE6 0%, #355AB0 100%);padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.imagedetail .right .mentalability .title i{width: 22px;display: inline-block;margin-right: 10px;position: relative;top:5px;}
.imagedetail .right .mentalability .item{padding:16px 16px 0;}
.imagedetail .right .mentalability .subtitle{font-size: 16px;}
.imagedetail .right .mentalability .subtitle span{position: relative;color: #fff;z-index: 2;width: 25px;display: inline-block;text-align: center;}
.imagedetail .right .mentalability .subtitle span::after{content:'';position: absolute;top:0;left: 0;width:25px;height:25px;background:#416ACC;z-index: -1;transform: rotate(45deg);border-radius: 4px;}
.imagedetail .right .mentalability .subtitle span:nth-child(2)::after{background: #D9993A;}
.imagedetail .right .mentalability .subtitle span:nth-child(3)::after{background: #76BF42;}
.imagedetail .right .mentalability .subtitle span:nth-child(4)::after{background: #D04A4A;}
.imagedetail .right .mentalability .content{font-size:14px;padding-top: 16px;}
.imagedetail .right .mentalability .item .items{display:flex;margin:10px 0;}
.imagedetail .right .mentalability .item .items p{flex: 1;}
.imagedetail .right .mentalability .item .items p span{display: inline-block;width:60px;text-align: right;}
.imagedetail .right .mentalability .item .items p:last-child{padding-left: 20px;}
.imagedetail .right .mentalability .item .items p label{font-size: 12px;padding: 0 5px;margin-left: 10px;}
.imagedetail .right .mentalability .Intellectualstructure{display: flex;flex-wrap: wrap;}
.imagedetail .right .mentalability .Intellectualstructure p{display: block;width: 50%;margin: 10px 0;}
.evaluate1{color: #FF6666;background: rgba(255, 102, 102, 0.1);}
.evaluate2{color: #E3B200;background: rgba(227, 178, 0, 0.1);}
.evaluate3{color: #FF9900;background: rgba(255, 153, 0, 0.1);}
.evaluate4{color: #2DCF50;background: rgba(45, 207, 80, 0.1);}
.evaluate5{color: #2561ED;background: rgba(37, 97, 237, 0.1);}

@keyframes driftanimation {
    0%{-webkit-transform: translate(0,0);}
    10%{-webkit-transform: translate(-5px,-5px);}
    20%{-webkit-transform: translate(-5px,0);}
    30%{-webkit-transform: translate(0,-5px);}
    40%{-webkit-transform: translate(0,0);}
    50%{-webkit-transform: translate(5px,0);}
    60%{-webkit-transform: translate(5px,5px);}
    70%{-webkit-transform: translate(0,5px);}
    80%{-webkit-transform: translate(0,0);}
    90%{-webkit-transform: translate(5px,-5px);}
    100%{-webkit-transform: translate(0,0);}
}
</style>